export class MarkupHelper {
    static calculate(priceSale, cost) {
      if (!priceSale || !cost ||cost <= 0) {
        return 0;
      }
      return priceSale / cost;
    }
  }
  